import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/me")
      .then((res) => { if (!cancelled) setUser(res.data); })
      .catch((err) => {
        if (err?.response?.status !== 401) console.error("Falha ao verificar sessão:", err);
        if (!cancelled) setUser(null);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const activate = useCallback(async (email, name, password) => {
    const res = await api.post("/auth/activate", { email, name, password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Falha ao encerrar sessão:", err);
    }
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, activate, logout }),
    [user, loading, login, activate, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
